import React from "react"
import camelCase from "lodash/camelCase"
import { RichText as PrismicRichText } from "prismic-reactjs"

import { Element, Text } from "legacy/components/shared/base"
import PaddedImageAndText from "./PaddedImageAndText"
import FullBleedImageAndText from "./FullBleedImageAndText"
import { Maybe } from "types/Maybe"
import { ImageAndTextType, ImageAndTextItemType } from "types/shared-components"

interface OwnProps {
  data: Maybe<ImageAndTextType>
}

export type ImageAndTextSectionProps = OwnProps

const ImageAndTextSection: React.FC<ImageAndTextSectionProps> = ({
  data,
}): React.ReactElement | null => {
  const repeater = data?.items
  const primary = data?.primary

  if (!repeater) return null

  const fullBleedImage = primary?.full_bleed_images || false
  const headlineText = primary.headline?.richText
  const imageStartsOn = primary?.image_starts_on || "left"
  const backgroundColor = primary?.background_color
    ? camelCase(primary?.background_color)
    : "white"
  const paddingTop = headlineText.length > 0 ? ["40", "80", "125px"] : 0

  return (
    <Element bg={backgroundColor} pt={paddingTop}>
      {headlineText.length > 0 ? (
        <Text
          as="h2"
          display="block"
          fontSize={["36", "42", "text.headerLarge"]}
          lineHeight={["44px", "1.4"]}
          mb={["30", "55"]}
          px="40"
          textAlign={["left", "center"]}
          variant="headerLarge"
        >
          {PrismicRichText.asText(headlineText)}
        </Text>
      ) : null}
      {repeater.map((item: ImageAndTextItemType, index: number) => {
        const indexIsEven = index % 2 === 0
        if (fullBleedImage) {
          return (
            <FullBleedImageAndText
              data={item}
              imageStartsOn={imageStartsOn}
              indexIsEven={indexIsEven}
              isFirst={index === 0}
              isLast={index === repeater.length - 1}
              key={"image_and_text_" + index}
              zIndex={1}
            />
          )
        } else {
          return (
            <PaddedImageAndText
              data={item}
              imageStartsOn={imageStartsOn}
              indexIsEven={indexIsEven}
              isFirst={index === 0}
              isLast={index === repeater.length - 1}
              key={"image_and_text_" + index}
              zIndex={1}
            />
          )
        }
      })}
    </Element>
  )
}

export default ImageAndTextSection
